import LayoutContent from '../../components/layouts/content2';
import React, { useState, useEffect } from 'react';
import ListProducts from './ListProducts';
import { useTranslation } from 'react-i18next';
import { getData } from '../../helpers/indexedDbHelper';
import SpecialsScreen from './specials';
import CoktailsScreen from './cocktail';
import SpecialityCocktail from './specialityCocktail';
import PeruvianClasic from './peruvianClasic';
import BeerScreen from './beer';
import SpiritsScreen from './spirits';

function Index({ dishs2, setShowBar }) {
  const { i18n } = useTranslation();
  const langEng = i18n.language === 'en' ?? false;

  const [menus, setMenus] = useState([]);
  const [showSpecials, setShowSpecials] = useState(false);
  const [showSpecialitylCocktail, setShowSpecialitylCocktail] = useState(false);
  const [showSesonalCocktail, setShowSesonalCocktail] = useState(false);
  const [showPeruvianClasic, setshowPeruvianClasic] = useState(false);
  const [showBeer, setshowBeer] = useState(false);
  const [showListProduct, setShowListProduct] = useState(false);
  const [dishs, setdishs] = useState(false);
  const [showspirits, setShowSpirits] = useState(false);
  const [datachampana, setdatachampana] = useState(false);
  const [datawine, setdatawine] = useState(false);
  const [databeers, setdatabeers] = useState(false);
  const [datamargaritas, setdatamargaritas] = useState(false);
  const [datacoladas, setdatacoladas] = useState(false);
  const [dataspiris, setdataspiris] = useState(false);
  const [tdatamartinis, settdatamartinis] = useState(false);
  const [datasangria, setdatasangria] = useState(false);
  const [datanoalcohol, setdatanoalcohol] = useState(false);

  useEffect(() => {
    getData('menu').then((items) => {
      const data = items.value.data;
      setMenus(data);
    });
  }, []);

  useEffect(() => {
    menus.map((item) => {
      if (item.id === 341) {
        setdatachampana(item);
      }
      if (item.id === 340) {
        setdatawine(item);
      }
      if (item.id === 393) {
        setdatabeers(item);
      }
      if (item.id === 389) {
        setdatamargaritas(item);
      }
      if (item.id === 390) {
        setdatacoladas(item);
      }
      if (item.id === 395) {
        setdataspiris(item);
      }
      if (item.id === 391) {
        settdatamartinis(item);
      }
      if (item.id === 392) {
        setdatasangria(item);
      }
      if (item.id === 417) {
        setdatanoalcohol(item);
      }
    });
  }, [menus]);

  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 9999,
      }}
    >
      <LayoutContent
        showImageTop={true}
        showBack={true}
        setShowSpecials={setShowSpecials}
        goHome={setShowBar}
        setShowListProduct={setShowBar}
      >
        <div style={{ padding: '0 10px', paddingLeft: 40 }}>
          <p
            style={{
              color: 'white',
              textAlign: 'center',
              fontSize: 40,
              fontWeight: '900',
              textTransform: 'uppercase',
            }}
          >
            drinks / bebidas
          </p>

          <div
            style={{
              display: 'flex',
              marginTop: 20,
              flexDirection: 'row',
              alignSelf: 'center',
              justifyContent: 'center',
              gap: 30,
            }}
          >
            <div
              onClick={() => setShowSesonalCocktail(true)}
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'relative',
                width: 250,
                height: 70,
                background: 'white',
                border: '1px solid #FEBA29',
                boxShadow: '5px 5px 2px 0px #ED3E08',
              }}
            >
              <div style={{ position: 'absolute' }}>
                <p
                  style={{
                    color: '#ED3E08',
                    textAlign: 'center',
                    fontSize: 40,
                    fontFamily: 'Watchtower',
                  }}
                >
                  COCKTAILS
                </p>
              </div>
            </div>

            <div
              onClick={() => {
                setdishs(databeers);
                setShowListProduct(true);
              }}
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'relative',
                width: 250,
                height: 70,
                background: 'white',
                border: '1px solid #FEBA29',
                boxShadow: '5px 5px 2px 0px #ED3E08',
              }}
            >
              <div style={{ position: 'absolute' }}>
                <p
                  style={{
                    color: '#ED3E08',
                    textAlign: 'center',
                    fontSize: 40,
                    fontFamily: 'Watchtower',
                  }}
                >
                  BEERS
                </p>
              </div>
            </div>
          </div>

          <div
            style={{
              display: 'flex',
              marginTop: 20,
              flexDirection: 'row',
              alignSelf: 'center',
              justifyContent: 'center',
              gap: 30,
            }}
          >
            <div
              onClick={() => {
                setdishs(datamargaritas);
                setShowListProduct(true);
              }}
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'relative',
                width: 250,
                height: 70,
                background: 'white',
                border: '1px solid #FEBA29',
                boxShadow: '5px 5px 2px 0px #ED3E08',
              }}
            >
              <div style={{ position: 'absolute' }}>
                <p
                  style={{
                    color: '#ED3E08',
                    textAlign: 'center',
                    fontSize: 35,
                    fontFamily: 'Watchtower',
                  }}
                >
                  MARGARITAS & MOJITOS
                </p>
              </div>
            </div>

            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'relative',
                width: 250,
                height: 70,
                background: 'white',
                border: '1px solid #FEBA29',
                boxShadow: '5px 5px 2px 0px #ED3E08',
              }}
            >
              <div style={{ position: 'absolute' }}>
                <p
                  style={{
                    color: '#ED3E08',
                    textAlign: 'center',
                    fontSize: 40,
                    fontFamily: 'Watchtower',
                  }}
                >
                  WINES
                </p>
              </div>
            </div>
          </div>

          <div
            style={{
              display: 'flex',
              marginTop: 20,
              flexDirection: 'row',
              alignSelf: 'center',
              justifyContent: 'center',
              gap: 30,
            }}
          >
            <div
              onClick={() => {
                setdishs(datacoladas);
                setShowListProduct(true);
              }}
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'relative',
                width: 250,
                height: 70,
                background: 'white',
                border: '1px solid #FEBA29',
                boxShadow: '5px 5px 2px 0px #ED3E08',
              }}
            >
              <div style={{ position: 'absolute' }}>
                <p
                  style={{
                    color: '#ED3E08',
                    textAlign: 'center',
                    fontSize: 40,
                    fontFamily: 'Watchtower',
                  }}
                >
                  COLADAS
                </p>
              </div>
            </div>

            <div
              onClick={() => {
                setdishs(dataspiris);
                setShowListProduct(true);
              }}
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'relative',
                width: 250,
                height: 70,
                background: 'white',
                border: '1px solid #FEBA29',
                boxShadow: '5px 5px 2px 0px #ED3E08',
              }}
            >
              <div style={{ position: 'absolute' }}>
                <p
                  style={{
                    color: '#ED3E08',
                    textAlign: 'center',
                    fontSize: 40,
                    fontFamily: 'Watchtower',
                  }}
                >
                  SPIRITS
                </p>
              </div>
            </div>
          </div>

          <div
            style={{
              display: 'flex',
              marginTop: 20,
              flexDirection: 'row',
              alignSelf: 'center',
              justifyContent: 'center',
              gap: 30,
            }}
          >
            <div
              onClick={() => {
                setdishs(tdatamartinis);
                setShowListProduct(true);
              }}
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'relative',
                width: 250,
                height: 70,
                background: 'white',
                border: '1px solid #FEBA29',
                boxShadow: '5px 5px 2px 0px #ED3E08',
              }}
            >
              <div style={{ position: 'absolute' }}>
                <p
                  style={{
                    color: '#ED3E08',
                    textAlign: 'center',
                    fontSize: 40,
                    fontFamily: 'Watchtower',
                  }}
                >
                  MARTINIS
                </p>
              </div>
            </div>

            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'relative',
                width: 250,
                height: 70,
                background: 'white',
                border: '1px solid #FEBA29',
                boxShadow: '5px 5px 2px 0px #ED3E08',
              }}
            >
              <div style={{ position: 'absolute' }}>
                <p
                  style={{
                    color: '#ED3E08',
                    textAlign: 'center',
                    fontSize: 39,
                    fontFamily: 'Watchtower',
                  }}
                >
                  BOTTLE SERVICES
                </p>
              </div>
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              marginTop: 20,
              flexDirection: 'row',
              alignSelf: 'center',
              justifyContent: 'center',
              gap: 30,
            }}
          >
            <div
              onClick={() => {
                setdishs(datasangria);
                setShowListProduct(true);
              }}
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'relative',
                width: 250,
                height: 70,
                background: 'white',
                border: '1px solid #FEBA29',
                boxShadow: '5px 5px 2px 0px #ED3E08',
              }}
            >
              <div style={{ position: 'absolute' }}>
                <p
                  style={{
                    color: '#ED3E08',
                    textAlign: 'center',
                    fontSize: 40,
                    fontFamily: 'Watchtower',
                  }}
                >
                  SANGRIA
                </p>
              </div>
            </div>

            <div
              onClick={() => {
                setdishs(datanoalcohol);
                setShowListProduct(true);
              }}
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'relative',
                width: 250,
                height: 70,
                background: 'white',
                border: '1px solid #FEBA29',
                boxShadow: '5px 5px 2px 0px #ED3E08',
              }}
            >
              <div style={{ position: 'absolute' }}>
                <p
                  style={{
                    color: '#ED3E08',
                    textAlign: 'center',
                    fontSize: 39,
                    fontFamily: 'Watchtower',
                  }}
                >
                  NON ALCOHOLIC
                </p>
              </div>
            </div>
          </div>

          <div
            style={{ width: '76%', margin: '10px auto' }}
            onClick={() => {
              //setShowDetailProduct(true);
              //setDataDish({ dish: ribeye, alldish: dataFood, currentDish: ribeye })
            }}
          >
            <img
              src={require('./assets/banner2.png')}
              style={{
                marginTop: 20,
                width: '100%',
                height: 220,
                objectFit: 'cover',
                borderRadius: 20,
              }}
            />
          </div>
        </div>

        {showSpecials && (
          <SpecialsScreen
            setShowHappy={setShowBar}
            setShowListProduct={setShowSpecials}
          />
        )}

        {showSesonalCocktail && (
          <CoktailsScreen
            goHome={setShowSesonalCocktail}
            setShowBar={setShowSesonalCocktail}
          />
        )}
        {showSpecialitylCocktail && (
          <SpecialityCocktail
            goHome={setShowBar}
            setShowListProduct={setShowSpecialitylCocktail}
          />
        )}
        {showPeruvianClasic && (
          <PeruvianClasic
            goHome={setShowBar}
            setShowListProduct={setshowPeruvianClasic}
          />
        )}
        {showBeer && (
          <BeerScreen goHome={setShowBar} setShowListProduct={setshowBeer} />
        )}
        {showspirits && (
          <SpiritsScreen
            goHome={setShowBar}
            setShowListProduct2={setShowSpirits}
          />
        )}

        {showListProduct && (
          <ListProducts
            dishs={dishs}
            goHome={setShowBar}
            setShowListProduct={setShowListProduct}
          />
        )}
      </LayoutContent>
    </div>
  );
}
export default Index;
